"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportModalComponent = void 0;
const core_1 = require("@angular/core");
const angular2_modal_1 = require("angular2-modal");
let SupportModalComponent = class SupportModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.isInvalid = false;
    }
    cancel() {
        this.dialog.close();
    }
    submit() {
        if (this.userInput) {
            this.dialog.close(this.userInput);
        }
        else {
            this.isInvalid = true;
        }
    }
};
exports.SupportModalComponent = SupportModalComponent;
exports.SupportModalComponent = SupportModalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'support-modal',
        styleUrls: [],
        template: `
    <div class="modal fade in" tabindex="-1" style="display:block">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
  
                <div class="modal-header">
                    <button type="button" class="close" (click)="cancel()">&times;</button>
                    <h4 class="modal-title">Support Request</h4>
                </div>
    
                <div class="modal-body">
                    <div class="row bottomMargin15">
                        <div class="col-xs-12">
                            Please enter the details of your request or the issue you are experiencing.
                            A member of our team will respond as soon as possible.
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="form-group" [ngClass]="{'has-error': isInvalid}">
                                <textarea style="resize:vertical" required class="form-control" [(ngModel)]="userInput" rows="5"></textarea>
                                <span *ngIf="isInvalid" class="help-block">Required</span>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="submit()">Ok</button>
                </div>
            </div>
        </div>
    </div>
`
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
], SupportModalComponent);
//# sourceMappingURL=support-modal.component.js.map